import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { DeleteAddress, GetAddress } from "../apis/Api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import AddressModal from "../components/models/AddressModal";
import MyProfile from "../common/MyProfile";

const SavedAddress = () => {
  const [addresses, setAddresses] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const getAddress = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("no user found");
      }

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const responsePromise = GetAddress({ cust_token: token });

      const response = await Promise.race([responsePromise, timeoutPromise]);
      if (response?.status === 200) {
        const addres = response.address ? JSON.parse(response.address) : [];

        setAddresses(addres);
      } else {
        throw new Error("no address found");
      }
    } catch (error) {
      if (error.status === 404) {
        setError("No address found.");

        return;
      }

      console.log("Error feching address:", error);
      setError(error.message || "Failed to load address. Please try again.");
      setAddresses([]);
      toast.error(`${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  const removeAddress = async (id) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("no user found");
      }

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Request timed out")), 10000)
      );

      const responsePromise = DeleteAddress({ id, cust_token: token });
      const response = await Promise.race([responsePromise, timeoutPromise]);
      if (response?.status === 200) {
        toast.success("Address removed successfully");

        setUpdateTrigger((prev) => prev + 1);
      } else {
        throw new Error("Invalid response data");
      }
    } catch (error) {
      if (error.status === 404) {
        setError("No address removed.");

        return;
      }

      setError(error.message || "Failed to remove address. Please try again.");
      setAddresses([]);
      toast.error(`${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAddress();
  }, [updateTrigger]);
  return (
    <div>
      <Header />
      <div id="content" className="no-top no-bottom">
        <div
          className="container mt-4 removetopspace "
          style={{ paddingTop: "170px" }}
        >
          <div className="row">
            <MyProfile />

            <div className="col-md-7">
              <h4 className="fw-bold">Saved Address</h4>
              <div className="d-flex justify-content-end mb-3">
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#addressModal"
                  className="btn  shadow-sm"
                  style={{
                    backgroundColor: "#73b734",
                    height: "40px",
                    width: "110px",
                    color: "white",
                  }}
                >
                  + Add New
                </button>
              </div>
              {addresses && addresses.length > 0 ? (
                addresses.map((address, index) => (
                  <div
                    key={index}
                    className="card p-3 shadow-sm mb-3"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #73b734",
                      backgroundColor: "#f9fff3",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <h6 style={{ color: "#73b734", fontWeight: "bold" }}>
                          {address.type}
                        </h6>
                        <p className="mb-1 text-secondary">{address.address}</p>
                      </div>
                      <button
                        onClick={() => removeAddress(address.id)}
                        className="btn"
                        style={{
                          height: "40px",
                          width: "100px",
                          fontWeight: "bold",
                          borderRadius: "8px",
                          border: "2px solid #73b734",
                          backgroundColor: "transparent",
                          color: "#73b734",
                          transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = "#73b734";
                          e.target.style.color = "#fff";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#73b734";
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p
                  className="text-muted text-center"
                  style={{ fontSize: "16px", padding: "20px" }}
                >
                  No addresses added yet.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <AddressModal
        setAddresses={setAddresses}
        setUpdateTrigger={setUpdateTrigger}
        addresses={addresses}
      />
    </div>
  );
};

export default SavedAddress;
